







































































import Vue, { PropOptions } from 'vue';
import { AppRoute } from '../../data/routes';
import sidebar from '../../store/modules/sidebar';
import SNavigationSidebar from '../SNavigationSidebar/SNavigationSidebar.vue';

import logoImage from '../../assets/logo.png';

export default Vue.extend({
  name: 'STopNav',
  components: {
    SNavigationSidebar,
  },
  props: {
    /**
     * An array of routes that will be used to populate the navigation sidebar.
     */
    sidebarRoutes: {
      type: Array,
      required: true,
    } as PropOptions<AppRoute[]>,
    /**
     * The name of the company using Aviso
     */
    appName: {
      type: String,
      required: true,
    },
    /**
     * Is the app in 'dark mode'
     */
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Whether the sidenav should be in its mini variant
     * https://vuetifyjs.com/en/components/navigation-drawers#mini
     */
    mini: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data(): any {
    return {
      logoImage,
    };
  },
  computed: {
    navDrawer: {
      get(): boolean {
        if (this.mini && this.$vuetify.breakpoint.mdAndUp) return true;
        return this.$store.state.sidebar.navDrawer;
      },
      set(value: boolean): void {
        this.$store.commit('sidebar/setNavDrawer', { open: value });
      },
    },
    isMini(): boolean {
      return this.mini && this.$vuetify.breakpoint.mdAndUp;
    },
    isDark(): boolean {
      return !this.mini || this.$vuetify.breakpoint.smAndDown;
    },
  },
  created(): void {
    const store = this.$store;
    if (!(store && store.state && store.state.sidebar)) {
      store.registerModule('sidebar', sidebar);
    } else {
      console.log('reusing module: sidebar');
    }
  },
  methods: {
    hamburgerClick(): void {
      this.navDrawer = !this.navDrawer;
    },
  },
});
